export default __webpack_public_path__ + "static/media/img-stake-atms.9526d24c.png";